import React, { useState } from 'react';
import { Chip, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CustomPagination from '../../../components/customPagination';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { useGetUploadErrorsHandler } from '../dataHandlers/getUploadErrorsHandler';

// Row-level rejection report for one upload session (the recon tool's errors
// drawer, as a dialog): row #, error code, detail.
const UploadErrorsDialog = ({ session, open, onClose }) => {
  const { reconciliation: r } = useTranslatedMessages();
  const t = r.upload_errors ?? {};

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);

  const { errors, totalErrors, isLoading } = useGetUploadErrorsHandler({
    sessionId: session?.upload_session_id,
    page,
    pageSize,
    enabled: open,
  });

  const columns = [
    {
      field: 'row_number',
      headerName: t.row ?? 'Row #',
      flex: 0.3,
      sortable: false,
    },
    {
      field: 'error_code',
      headerName: t.code ?? 'Error Code',
      flex: 0.6,
      sortable: false,
      renderCell: (params) => <Chip size="small" variant="outlined" color="error" label={params.row.error_code} />,
    },
    {
      field: 'error_detail',
      headerName: t.detail ?? 'Detail',
      flex: 1.6,
      sortable: false,
    },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {t.title ?? 'Rejected rows'}
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {session?.file_name}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DataGrid
          columns={columns}
          rows={errors}
          getRowId={(row) => row.row_number}
          autoHeight
          disableRowSelectionOnClick
          loading={isLoading}
          paginationMode="server"
          rowCount={totalErrors}
          initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
          pageSizeOptions={[25, 100]}
          onPaginationModelChange={({ page: nextPage, pageSize: nextSize }) => {
            setPage(nextPage);
            setPageSize(nextSize);
          }}
          slots={{ pagination: CustomPagination }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default UploadErrorsDialog;
